import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5fcd868e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "sales-report-new-filter-sales" };
const _hoisted_2 = { class: "sales-report-new-filter-sales__label" };
const _hoisted_3 = { class: "popvoer-text" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px" }, null, -1));
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("a", {
    href: "https://ajuda.otocrm.com.br/support/solutions/articles/150000031750-relat%C3%B3rio-de-vendas",
    target: "_blank"
}, [
    /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-14px" })
], -1));
import vSelect from 'vue-select';
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
// services
import { fetchFilterSale } from '@/features/SalesReportNew/data/index';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FilterSales',
    setup(__props) {
        // libs
        const store = useStore();
        const saleSelected = ref({
            key: 'allSellings',
            name: 'Todas as vendas',
        });
        const salesOptions = ref([]);
        const isLoading = ref(false);
        // actions
        const changeSelectedSale = (contact) => store.dispatch('salesReportNew/setOriginSale', contact);
        const selectSale = (contact) => {
            const key = contact.key;
            changeSelectedSale(key);
        };
        const fetchOptions = () => {
            isLoading.value = true;
            fetchFilterSale()
                .then(response => {
                salesOptions.value = response?.data;
            })
                .finally(() => {
                isLoading.value = false;
            });
        };
        onMounted(() => {
            fetchOptions();
        });
        return (_ctx, _cache) => {
            const _component_el_popover = _resolveComponent("el-popover");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.$t('origin-sale')), 1),
                    _createVNode(_component_el_popover, {
                        trigger: "hover",
                        placement: "top",
                        width: 280
                    }, {
                        reference: _withCtx(() => [
                            _hoisted_5
                        ]),
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("p", null, _toDisplayString(_ctx.$t('campaign.sales-report.header.filter.origin-sale-tooltip-first-part')), 1),
                                _createElementVNode("p", null, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('campaign.sales-report.header.filter.origin-sale-tooltip-second-part')) + " ", 1),
                                    _hoisted_4,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('campaign.sales-report.header.filter.origin-sale-tooltip-third-part')), 1)
                                ])
                            ])
                        ]),
                        _: 1
                    })
                ]),
                _createVNode(_unref(vSelect), {
                    modelValue: saleSelected.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((saleSelected).value = $event)),
                    label: "name",
                    clearable: false,
                    options: salesOptions.value,
                    loading: isLoading.value,
                    "onOption:selected": selectSale
                }, {
                    option: _withCtx(({ name }) => [
                        _createTextVNode(_toDisplayString(_ctx.$tc(name, 1)), 1)
                    ]),
                    "selected-option": _withCtx(({ name }) => [
                        _createTextVNode(_toDisplayString(_ctx.$tc(name, 1)), 1)
                    ]),
                    "open-indicator": _withCtx(({ attributes }) => [
                        _createElementVNode("span", _mergeProps(attributes, { class: "arrow-down" }), null, 16)
                    ]),
                    "no-options": _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('campaign.sales-report.no-results')), 1)
                    ]),
                    _: 1
                }, 8, ["modelValue", "options", "loading"])
            ]));
        };
    }
});
